var _defs, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChrismongemeinde2025AblaufgrafikDesktopRgb = function SvgChrismongemeinde2025AblaufgrafikDesktopRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 540,
    height: 160,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 160",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_44",
    "data-name": "Unbenannter Verlauf 44",
    x1: -1657.82,
    y1: 2934.65,
    x2: -1637.7,
    y2: 2934.65,
    gradientTransform: "translate(1703.89 -2884.87) rotate(.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcf4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f7bea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f38079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ec2c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb1527"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_39",
    "data-name": "Unbenannter Verlauf 39",
    cx: 249.22,
    cy: 1459.48,
    fx: 249.22,
    fy: 1459.48,
    r: 20.96,
    gradientTransform: "translate(0 -1413.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_59",
    "data-name": "Unbenannter Verlauf 59",
    x1: 239.77,
    y1: 47.11,
    x2: 258.62,
    y2: 47.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3daee4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#65bfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#87cddb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a3d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#b9e2d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c8e9d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d1ecd3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.77,120.33v1.3h-5.4v6.26h-1.5v-13.34h7.32v1.3h-5.82v4.48h5.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.13,115.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM394.85,118.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.89,118.41c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.67,120.89c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM413.09,122.75c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.87,114.49v13.4h-1.48v-13.4h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.69,123.39c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM427.71,122.29c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,119.57c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM433.77,126.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.75,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM385.57,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.79,140.81c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM409.71,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.81,147.47v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM423.19,140.67l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.31,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.57,138.48v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM440.55,147.19c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.09,139.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM450.81,142.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.67,145.01c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.65,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM469.47,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.41,142.21c.12-2.22,1.48-3.52,3.72-3.52s3.6,1.3,3.6,3.24c0,1.36-.64,2.3-1.96,2.88,1.62.56,2.38,1.62,2.38,3.26,0,2.42-1.64,4-4.14,4s-4.06-1.42-4.06-3.68v-.2h1.32c.06,1.68,1,2.6,2.68,2.6s2.72-1,2.72-2.66-1.04-2.56-3.1-2.56c-.14,0-.26,0-.48.02v-1.28l.52.02c1.62,0,2.62-.86,2.62-2.3,0-1.26-.84-2.06-2.2-2.06s-2.12.72-2.32,2.24h-1.3Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.07,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.07,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM495.89,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.99,147.47v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM509.37,140.67l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.49,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 401.84,
    y: 54.76,
    width: 6.54,
    height: 50.32,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.2,49.95l-4.06,7.14c-1.35,2.48-.6,5.56,1.73,7.14,2.33,1.58,5.56.6,7.14-2.1l4.06-7.14-8.87-5.04h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.16,49.95l4.06,7.14c1.35,2.48.6,5.56-1.73,7.14-2.33,1.58-5.56.6-7.14-2.1l-4.06-7.14,8.87-5.04h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.95,75.21l16.76,7.67-16.76,7.89c-.98.23-1.73.38-2.71.38-4.81,0-8.49-3.68-8.49-8.27s3.83-8.27,8.49-8.27c.75.23,1.35,0,2.71.6",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.64,
    y1: 82.88,
    x2: 408.37,
    y2: 82.88,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.23,42.64v-2.42c-.16-8.55,6.61-15.48,14.99-15.64,8.38-.16,15.48,6.61,15.64,14.99v2.42",
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.54,
    cy: 42.31,
    r: 15.32,
    style: {
      fill: "#fff7bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.54,
    cy: 42.31,
    r: 12.74,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "404.74 33.77 407.64 33.77 408.12 50.86 405.06 50.86 404.9 39.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "404.74 39.09 402.64 42.64 400.06 41.02 404.74 33.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M424.34,10.55v1.61c0,3.89,2.56,7.11,5.63,7.11h1.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,10.55v1.61c0,3.89-2.56,7.11-5.63,7.11h-1.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,27.99v-1.61c0-3.89,2.56-7.11,5.63-7.11h1.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,27.99v-1.61c0-3.89-2.56-7.11-5.63-7.11h-1.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M384.23,63.19v1.41c0,3.41,2.24,6.23,4.94,6.23h1.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.23,63.19v1.41c0,3.41-2.24,6.23-4.94,6.23h-1.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.23,78.36v-1.41c0-3.41,2.24-6.23,4.94-6.23h1.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.23,78.36v-1.41c0-3.41-2.24-6.23-4.94-6.23h-1.01",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.93,114.55c1.8,0,2.52.08,3.26.32,1.3.44,2.06,1.54,2.06,3s-.7,2.44-2.22,2.92c2,.48,2.92,1.56,2.92,3.38,0,1.64-.88,2.96-2.24,3.38-.86.28-1.6.34-3.9.34h-2.32v-13.34h2.44ZM17.23,120.29c1.3,0,1.94-.1,2.5-.42.64-.34,1-1.06,1-1.9,0-.92-.44-1.64-1.2-1.92-.52-.2-.98-.24-2.38-.24h-1.18v4.48h1.26ZM17.31,126.63c1.6,0,2.28-.08,2.88-.34.74-.32,1.18-1.14,1.18-2.2,0-1.12-.58-1.98-1.52-2.3-.6-.18-1.12-.24-2.54-.24h-1.34v5.08h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.09,123.39c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM31.11,122.29c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05,118.41l2.04,7.52,2.22-7.52h1.2l2.22,7.52,2.04-7.52h1.44l-2.74,9.6h-1.38l-2.18-7.44-2.2,7.44h-1.36l-2.74-9.6h1.44Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.73,123.39c.06,2.3,1.02,3.54,2.74,3.54,1.04,0,1.66-.4,2.2-1.44l1.3.16c-.58,1.64-1.78,2.48-3.52,2.48-2.54,0-4.16-1.9-4.16-4.88s1.6-5.1,4.08-5.1c2.34,0,3.84,1.9,3.84,4.84,0,.06,0,.22-.02.4h-6.46ZM53.75,122.29c-.16-1.92-1.02-2.96-2.44-2.96s-2.26,1.02-2.54,2.96h4.98Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.77,118.41c.12.48.18.98.18,1.46,0,.12,0,.32-.02.58.66-1.58,1.42-2.3,2.44-2.3.36,0,.74.1,1.14.3v1.4c-.64-.3-.9-.38-1.26-.38-.74,0-1.4.54-1.82,1.46-.3.66-.42,1.46-.42,2.72v4.24h-1.42v-6.22c0-2.16-.02-2.34-.16-3.26h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.51,114.48v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM65.49,123.19c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,118.41v5.8c0,1.06.1,1.58.36,1.94.32.46.9.72,1.58.72.84,0,1.52-.4,1.94-1.1.28-.48.38-1.04.38-1.98v-5.38h1.4v6.6c0,2.06,0,2.18.22,2.88h-1.38c-.14-.42-.18-.76-.2-1.26-.56,1.06-1.3,1.5-2.52,1.5s-2.3-.56-2.8-1.52c-.3-.52-.38-1.1-.38-2.4v-5.8h1.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31,118.41c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.05,119.47l-1.94-.04c.52.48.82,1.3.82,2.18s-.34,1.72-.96,2.16c-.42.32-1.08.56-2.14.78-.94.2-1.14.26-1.44.4-.36.18-.56.4-.56.64,0,.4.22.48,1.9.64,1.86.18,2.42.3,3.04.64.76.44,1.2,1.22,1.2,2.16,0,1.82-1.64,2.94-4.3,2.94s-4.26-1.08-4.26-2.74c0-1.14.6-1.84,2-2.34-.74-.28-1.02-.6-1.02-1.1,0-.64.46-1.06,1.7-1.52-1.3-.52-1.9-1.4-1.9-2.74,0-1.96,1.38-3.24,3.48-3.24.52,0,.92.06,1.48.22l2.9-.1v1.06ZM94.69,129.15c0,1,1.18,1.66,3,1.66s2.92-.64,2.92-1.66-1.06-1.64-3.02-1.64c-1.84,0-2.9.6-2.9,1.64ZM95.52,121.49c0,1.18.82,1.96,2.04,1.96s2.04-.78,2.04-1.96-.82-2.08-1.96-2.08c-1.26,0-2.12.84-2.12,2.08Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19,119.57c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM106.19,126.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.03,144.89c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM19.45,146.75c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.15,138.48v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM25.13,147.19c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.83,145.01c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.39,147.15c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM48.55,147.09c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73,142.41v1.14h-2.3v8.34h-1.48v-8.34h-1.34v-1.14h1.34v-.6c0-1.42.08-1.9.4-2.44.4-.7,1.2-1.1,2.12-1.1.48,0,.94.1,1.5.3v1.3c-.5-.26-.9-.36-1.32-.36-.58,0-.98.28-1.14.82-.1.28-.14.72-.14,1.44v.64h2.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,147.15c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM64.23,147.09c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62,142.41c.12.48.18.98.18,1.46,0,.12,0,.32-.02.58.66-1.58,1.42-2.3,2.44-2.3.36,0,.74.1,1.14.3v1.4c-.64-.3-.9-.38-1.26-.38-.74,0-1.4.54-1.82,1.46-.3.66-.42,1.46-.42,2.72v4.24h-1.42v-6.22c0-2.16-.02-2.34-.16-3.26h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.71,142.41v1.14h-2.26l-.1,4.8v.94c0,.66.02.9.14,1.14.12.28.46.44.92.44.42,0,.94-.12,1.36-.34v1.24c-.64.24-1.1.32-1.68.32-.94,0-1.64-.32-1.96-.9-.18-.32-.24-.66-.24-1.34,0-.18,0-.5.02-.8l.02-.74.12-4.76h-1.42v-1.14h1.46l.06-2.74h1.36l-.04,2.74h2.24Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2,138.48v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM93.19,147.19c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,139.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM103.44,142.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,145.01c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.29,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM122.11,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.32,140.81c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM146.24,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,147.47v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM159.73,140.67l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 62.76,
    width: 6.54,
    height: 42.32,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51,59.04l-3.47,6.11c-1.16,2.12-.51,4.76,1.48,6.11,1.99,1.35,4.76.51,6.11-1.8l3.47-6.11-7.59-4.31h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,59.04l3.47,6.11c1.16,2.12.51,4.76-1.48,6.11s-4.76.51-6.11-1.8l-3.47-6.11,7.59-4.31h0Z",
    style: {
      fill: "#ffecde",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.82,83.21l16.76,7.67-16.76,7.89c-.98.23-1.73.38-2.71.38-4.81,0-8.49-3.68-8.49-8.27s3.83-8.27,8.49-8.27c.75.23,1.35,0,2.71.6",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.5,
    y1: 90.88,
    x2: 54.24,
    y2: 90.88,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "41.38 30.12 46.71 16.71 56.19 17 60.67 30.53 57.9 32.35 56.51 35.56 56.26 37.13 54.76 32.35 52.94 30.31 49.84 30.49 47.91 32.79 45.61 36.54 44.12 32.13 41.75 30.85 41.38 30.12",
    style: {
      fill: "#ffecde"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.64 30.74 43.39 31.04 45.32 35.01 45.68 36.62 48.53 32.17 49.81 30.67 51.63 30.67 53.49 31.44 55.42 34.61 55.79 37.02 56.99 34.94 58.45 31.44 61.04 30.67 61.33 62.7 41.2 63.14 41.64 30.74",
    style: {
      fill: "url(#Unbenannter_Verlauf_44)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.04 30.31 51.23 5.04 41.27 30.23 41.31 63.03 61.18 63.07 61.04 30.31",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "51.23 5.04 45.79 19.29 56.66 19.29 51.23 5.04"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.97,39.97c0-5.32-2.19-9.55-4.96-9.55s-4.78,4.19-4.89,9.48",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.04,30.53c-2.77,0-5.07,4.34-4.96,9.55l-.04,22.8",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.35,30.31c2.77,0,5.07,4.34,4.96,9.55l-.04,23.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.98,17.52v1.6c0,3.67,2.44,6.71,5.18,6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98,17.52v1.6c0,3.67-2.44,6.71-5.18,6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98,33.8v-1.6c0-3.67,2.44-6.71,5.18-6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98,33.8v-1.6c0-3.67-2.44-6.71-5.18-6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.65,51.24v1.88c0,4.33,2.87,7.91,6.11,7.91h1.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,51.24v1.88c0,4.33-2.87,7.91-6.11,7.91h-1.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,70.45v-1.88c0-4.33,2.87-7.91,6.11-7.91h1.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,70.45v-1.88c0-4.33-2.87-7.91-6.11-7.91h-1.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.33,128.05h-1.82l-1.58-1.66c-.98,1.14-2.28,1.72-3.78,1.72-3.2,0-5.42-2.82-5.42-6.9s2.22-6.9,5.44-6.9,5.42,2.82,5.42,6.88c0,1.54-.26,2.78-.88,4.04l2.62,2.82ZM208.33,121.15c0,3.4,1.54,5.66,3.84,5.66s3.82-2.28,3.82-5.58-1.56-5.6-3.84-5.6-3.82,2.28-3.82,5.52Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.65,118.41v5.8c0,1.06.1,1.58.36,1.94.32.46.9.72,1.58.72.84,0,1.52-.4,1.94-1.1.28-.48.38-1.04.38-1.98v-5.38h1.4v6.6c0,2.06,0,2.18.22,2.88h-1.38c-.14-.42-.18-.76-.2-1.26-.56,1.06-1.3,1.5-2.52,1.5s-2.3-.56-2.8-1.52c-.3-.52-.38-1.1-.38-2.4v-5.8h1.4Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.03,120.89c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM235.45,122.75c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,114.49v13.4h-1.48v-13.4h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,115.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM245.65,118.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.57,118.41v1.14h-2.3v8.34h-1.48v-8.34h-1.34v-1.14h1.34v-.6c0-1.42.08-1.9.4-2.44.4-.7,1.2-1.1,2.12-1.1.48,0,.94.1,1.5.3v1.3c-.5-.26-.9-.36-1.32-.36-.58,0-.98.28-1.14.82-.1.28-.14.72-.14,1.44v.64h2.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,115.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM256.07,118.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,114.49v13.4h-1.4v-13.4h1.4ZM266.13,118.41l-3.96,4.26,4.26,5.22h-1.94l-4.06-5.16,4-4.32h1.7Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.99,120.89c.2-1.78,1.44-2.74,3.54-2.74,1.54,0,2.68.58,3.04,1.56.18.48.22.94.22,2.12v3.56c0,1.54.04,1.84.26,2.5h-1.34c-.14-.44-.16-.66-.22-1.28-.56,1.02-1.48,1.52-2.78,1.52-1.86,0-3.06-1.08-3.06-2.74,0-1.32.76-2.3,2.2-2.84.92-.34,1.8-.54,3.56-.84v-.4c0-1.42-.54-1.96-1.94-1.96-1.22,0-1.9.48-2.1,1.54h-1.38ZM273.41,122.75c-3.2.56-4.32,1.24-4.32,2.54,0,.98.74,1.66,1.84,1.66.92,0,1.72-.44,2.12-1.18.24-.46.36-1.1.36-2.08v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,118.41v1.14h-2.26l-.1,4.8v.94c0,.66.02.9.14,1.14.12.28.46.44.92.44.42,0,.94-.12,1.36-.34v1.24c-.64.24-1.1.32-1.68.32-.94,0-1.64-.32-1.96-.9-.18-.32-.24-.66-.24-1.34,0-.18,0-.5.02-.8l.02-.74.12-4.76h-1.42v-1.14h1.46l.06-2.74h1.36l-.04,2.74h2.24Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75,115.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM285.47,118.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,123.15c0,2.92-1.7,4.98-4.14,4.98s-4.14-2.04-4.14-5.06c0-2.86,1.72-4.92,4.14-4.92s4.14,2.04,4.14,5ZM289.29,123.09c0,2.32,1.06,3.84,2.7,3.84s2.7-1.52,2.7-3.8-1.08-3.78-2.7-3.78-2.7,1.52-2.7,3.74Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.59,118.41c.14.4.2.78.2,1.38.64-1.1,1.6-1.64,2.86-1.64s2.3.58,2.72,1.54c.26.62.3.88.3,2.76v5.44h-1.4v-5.36c0-1.44-.04-1.78-.26-2.24-.3-.58-.86-.9-1.64-.9-.86,0-1.64.44-2.08,1.18-.28.5-.42,1.12-.42,2.02v5.3h-1.4v-6.26c0-2.26,0-2.34-.22-3.22h1.34Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,119.57c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16ZM310.81,126.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.15,140.81c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.39,140.81c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.49,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM232.31,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25,142.21c.12-2.22,1.48-3.52,3.72-3.52s3.6,1.3,3.6,3.24c0,1.36-.64,2.3-1.96,2.88,1.62.56,2.38,1.62,2.38,3.26,0,2.42-1.64,4-4.14,4s-4.06-1.42-4.06-3.68v-.2h1.32c.06,1.68,1,2.6,2.68,2.6s2.72-1,2.72-2.66-1.04-2.56-3.1-2.56c-.14,0-.26,0-.48.02v-1.28l.52.02c1.62,0,2.62-.86,2.62-2.3,0-1.26-.84-2.06-2.2-2.06s-2.12.72-2.32,2.24h-1.3Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.91,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.17,138.49v5.3c.72-1.14,1.54-1.64,2.72-1.64,2.18,0,3.68,2,3.68,4.96s-1.54,5.02-3.84,5.02c-1.18,0-1.96-.48-2.62-1.58v.22c0,.38-.04.72-.16,1.12h-1.34c.14-.58.16-1.04.16-2.68v-10.72h1.4ZM263.15,147.19c0,2.24,1,3.72,2.5,3.72s2.48-1.48,2.48-3.8-.92-3.74-2.38-3.74c-1.58,0-2.6,1.5-2.6,3.82Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,139.41c0,.58-.42,1-1.02,1s-1.02-.42-1.02-1,.44-1.04,1.04-1.04,1,.44,1,1.04ZM273.41,142.41v9.48h-1.48v-9.48h1.48Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,145.01c-.14-1.16-.76-1.7-1.94-1.7-1.08,0-1.82.58-1.82,1.42,0,.78.4,1.08,2.2,1.6,1.56.46,2.14.74,2.54,1.2.36.42.54.98.54,1.64,0,1.82-1.32,2.96-3.44,2.96-2.3,0-3.58-1.14-3.58-3.18h1.36c.12,1.34.84,2,2.2,2,1.24,0,2.02-.66,2.02-1.66,0-.52-.2-.86-.64-1.12-.32-.2-.44-.24-2.08-.76-1.84-.56-2.54-1.26-2.54-2.58,0-1.6,1.32-2.68,3.26-2.68s3.18,1.02,3.28,2.86h-1.36Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM292.07,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.29,140.81c1.66-.06,2.46-.64,2.76-2.02h1v13.1h-1.42v-10.14h-2.34v-.94Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.39,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.39,145.39c0,4.16-1.6,6.68-4.28,6.68-1.18,0-2.22-.52-2.88-1.42-.9-1.26-1.38-3.06-1.38-5.24,0-4.24,1.6-6.72,4.32-6.72s4.22,2.56,4.22,6.7ZM316.21,141.09c-.56,1.04-.86,2.54-.86,4.32s.3,3.24.86,4.26c.4.76,1.08,1.18,1.9,1.18s1.52-.42,1.92-1.18c.56-1.04.86-2.54.86-4.28s-.32-3.32-.86-4.3c-.4-.76-1.1-1.18-1.88-1.18-.86,0-1.52.4-1.94,1.18Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.31,147.47v1.26h-2.24v3.28h-1.46v-3.28h-5.34v-1.12l5.28-8.82h1.5v8.68h2.26ZM329.69,140.67l-4,6.8h3.98l.02-6.8Z",
    style: {
      fill: "#eb1426"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.81,150.95c0,.62-.52,1.14-1.16,1.14s-1.14-.52-1.14-1.14c0-.66.52-1.16,1.16-1.16s1.14.52,1.14,1.16Z",
    style: {
      fill: "#eb1426"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.39,
    y: 54.76,
    width: 6.54,
    height: 50.32,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M263.5,75.21l16.76,7.67-16.76,7.89c-.98.23-1.73.38-2.71.38-4.81,0-8.49-3.68-8.49-8.27s3.83-8.27,8.49-8.27c.75.23,1.35,0,2.71.6",
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.19,
    y1: 82.88,
    x2: 251.93,
    y2: 82.88,
    style: {
      fill: "#e4f5e7",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.08,14.38v1.6c0,3.67,2.44,6.71,5.18,6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,14.38v1.6c0,3.67-2.44,6.71-5.18,6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,30.66v-1.6c0-3.67,2.44-6.71,5.18-6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.08,30.66v-1.6c0-3.67-2.44-6.71-5.18-6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.33,57.94v1.6c0,3.67,2.44,6.71,5.18,6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,57.94v1.6c0,3.67-2.44,6.71-5.18,6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,74.23v-1.6c0-3.67,2.44-6.71,5.18-6.71h1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,74.23v-1.6c0-3.67-2.44-6.71-5.18-6.71h-1.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_13-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.92 39.4 230.4 41.43 228.36 44.73 228.94 48.71 231.46 51.72 232.82 52.69 232.73 56.96 234.47 60.84 236.7 62.29 240.2 62.39 242.62 62.39 244.66 65.01 248.44 66.95 251.64 66.95 253.87 64.72 255.91 62.49 259.5 62.68 262.99 62.39 265.03 59.67 265.9 56.96 265.42 52.88 268.14 50.75 270.17 48.13 270.17 46.09 269.2 42.89 267.26 40.56 265.61 39.4 265.9 36.1 265.42 33.38 263.58 30.96 261.15 29.69 258.34 29.4 255.72 29.4 254.17 27.37 251.93 25.81 249.22 25.13 245.92 26.2 243.49 28.43 242.62 29.69 239.13 29.4 236.8 29.69 233.79 32.12 232.73 34.64 232.92 37.65 232.92 39.4",
    style: {
      fill: "url(#Unbenannter_Verlauf_39)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.62,29.6c1.65-2.81,3.98-4.46,6.6-4.46s4.85,1.65,6.5,4.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.62,62.39c1.65,2.81,3.98,4.56,6.69,4.56s4.95-1.75,6.6-4.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.82,52.59c-2.81-1.65-4.56-3.98-4.56-6.6s1.75-5.04,4.56-6.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.61,52.69c2.81-1.65,4.56-3.98,4.56-6.69s-1.75-5.04-4.56-6.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,58.6c-5.14,4.37-11.54,5.34-14.75,2.13-3.2-3.2-2.23-9.6,2.23-14.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.93,45.9c4.27-5.14,5.34-11.45,2.13-14.65s-9.6-2.13-14.75,2.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,33.38c-5.14-4.37-11.54-5.34-14.75-2.13-3.2,3.2-2.23,9.6,2.23,14.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.83,45.99c4.37,5.24,5.43,11.54,2.23,14.75-3.2,3.2-9.6,2.13-14.84-2.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.77,47.31v-1.49c-.1-5.26,4.07-9.53,9.23-9.62s9.53,4.07,9.62,9.23v1.49",
    style: {
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.2,
    cy: 47.11,
    r: 9.43,
    style: {
      fill: "url(#Unbenannter_Verlauf_59)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.2,
    cy: 47.11,
    r: 7.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.86 50.98 245.29 47.73 246.62 46.26 248.63 48.09 252.02 43.84 253.57 45.08 248.86 50.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChrismongemeinde2025AblaufgrafikDesktopRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chrismongemeinde2025-ablaufgrafik-desktop-rgb.bf99d01394678f31c0e1fa12d23b2485.svg";